module.exports = __webpack_public_path__ + "img/152.55db94b4.png";